import { toggle } from "./toggle";

export default toggle("navigation-enabled");
